import styles from './Cell.module.css';
import useApi from '../../services/useApi';
import { useRecoilState } from 'recoil';
import { newTaskConfig, namespaceState } from '../../recoil/atoms';
import { useEffect, useRef, useState } from 'react';
import NaviButton from '../../compoenets/NaviButton';

export default function Cell(props){
    const {packageName, appName, versionList, dataType,iconUrl}=props;
    const iconFullUrl=process.env.REACT_APP_NGP_SERVICE_URL.replace(/\/$/,'')+iconUrl;
    const [,setTaskConfig] = useRecoilState(newTaskConfig);
    const [nsState,] = useRecoilState(namespaceState);
    const dropdownRef=useRef(null);
    const [isDropdown,setIsDropdown]=useState(false);
    const [isVersion,setIsVersion]=useState("none");

    const handleVersion=(version)=>{
        setIsVersion(version)
        setIsDropdown(false);
    }

    const handleClickOutside=(e)=>{
        if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
            setIsDropdown(false)
        }
    }

    const handleSelect=()=>{
        setTaskConfig((prevData) => ({
          ...prevData,
          appData: props,
          packageName:packageName,
          minPackageVersion:isVersion
        }));
        return true;
    }

    useEffect(()=>{
        if(isDropdown){
            document.addEventListener('click',handleClickOutside)
        }else{
            document.removeEventListener('click',handleClickOutside)
        }
        return()=>{
            document.removeEventListener('click',handleClickOutside)
        }
    },[isDropdown])

    return(
        <div className={styles['wrap']}>
            <header>
                <div style={{
                    background: `
                    radial-gradient(circle , transparent 24px, var(--color-hover) 11px),
                    ${appName==='message'?
                    `url("${iconFullUrl}") center no-repeat`:
                    appName==='experiment'?
                    `url("${iconFullUrl}") center / 32px no-repeat`:
                    `url("${iconFullUrl}") center / 32px no-repeat`
                    }`
                }}/>
                <button/>
            </header>
            <body>
                <span>{packageName}</span>
                <span>{appName.charAt(0).toUpperCase()+ appName.slice(1)}</span>
                <p>
                    {dataType.map((item)=>
                    <span>{item}</span>
                    )}
                </p>
            </body>
            <hr/>
            <footer>
                <p ref={dropdownRef}>
                    <span>min-version</span>
                    <button 
                    className={`${styles['dropdown-btn']} ${isDropdown&&styles['dropdown-btn-on']}`}
                    onClick={()=>setIsDropdown(!isDropdown)}
                    >
                        {isVersion}
                    </button>
                    {isDropdown&&<ul className={styles['dropdown']}>
                        {versionList.map((item)=>
                        <li onClick={()=>handleVersion(item)}>{item}</li>
                        )}
                    </ul>}
                </p>
                <NaviButton 
                to="/new-task-data-v2" 
                handleBtn={handleSelect}>
                    Select
                </NaviButton>
            </footer>
        </div>
    )
}
